if (!customElements.get('zapiet-picker')) {
  customElements.define(
    'zapiet-picker',
    class ZapietPicker extends HTMLElement {
      connectedCallback() {
        this.#initCheckoutGate();
        this.#injectStylesWhenReady();
      }

      #initCheckoutGate() {
        const checkoutBtn = document.querySelector('#main-cart-footer #checkout');
        if (!checkoutBtn) return;

        checkoutBtn.dataset.awaitingCheckoutConditions =
          +checkoutBtn.dataset.awaitingCheckoutConditions || 0;
        checkoutBtn.dataset.awaitingCheckoutConditions =
          +checkoutBtn.dataset.awaitingCheckoutConditions + 1;
        checkoutBtn.disabled = true;

        if (window.ZapietEvent) {
          window.ZapietEvent.listen('checkoutEnabled', () => {
            checkoutBtn.dataset.awaitingCheckoutConditions =
              +checkoutBtn.dataset.awaitingCheckoutConditions - 1;

            if (+checkoutBtn.dataset.awaitingCheckoutConditions === 0) {
              checkoutBtn.disabled = false;
            }
          });
        }
      }

      #injectStylesWhenReady() {
        const href = this.dataset.zapietStyles;
        if (!href) return;

        const inject = () => {
          let link = document.getElementById('wonderly-zapiet-cart-styles');

          if (!link) {
            link = document.createElement('link');
            link.id = 'wonderly-zapiet-cart-styles';
            link.rel = 'stylesheet';
            link.href = href;
          }

          document.head.appendChild(link);
        };

        const bindWidgetLoaded = () => {
          window.ZapietEvent.listen('widget_loaded', inject);
          window.ZapietEvent.listen('selected_method', inject);
        };

        if (window.ZapietEvent) {
          bindWidgetLoaded();
        } else {
          const start = Date.now();
          const poll = window.setInterval(() => {
            if (window.ZapietEvent) {
              window.clearInterval(poll);
              bindWidgetLoaded();
            } else if (Date.now() - start > 20000) {
              window.clearInterval(poll);
            }
          }, 100);
        }

        const observer = new MutationObserver(() => {
          if (this.querySelector('#storePickupApp .checkoutMethod')) {
            inject();
          }
        });

        observer.observe(this, { childList: true, subtree: true });

        if (this.querySelector('#storePickupApp .checkoutMethod')) {
          inject();
        }
      }
    }
  );
}
